import invariant from './invariant';

export function findInvariant<T = unknown>(bucket: T[], comparator: (row: T) => boolean, message?: string) {
  const row = bucket.find(comparator);
  invariant(row, message ?? 'Row not found');
  return row;
}
